import script from "./PatientListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientListView.vue?vue&type=script&lang=ts&setup=true"

import "./PatientListView.vue?vue&type=style&index=0&id=4d43d3a2&lang=scss"

const __exports__ = script;

export default __exports__